<template>
	<div>
		<h2 >Mapa de Hallazgos </h2>
		<br>
		<!-- <div> -->
			<!-- <export-ex :name="name" :config_name="`${rq_name}/a/all`" style="margin: 0 !important">Descargar KMZ</export-ex> -->
			<!--  :ex_permission="14" -->
		<!-- </div> -->
		<br>
		<div style="background: lightgrey">
			<iframe src="https://www.google.com/maps/d/embed?mid=1tRBg3ZwV4pa6ICHvU9v4aESKw0HFtPo&ehbc=2E312F&noprof=1" width="100%" height="700"></iframe>
		</div>
	</div>
</template>
<script>

export default {
	data() {
		return {
			rq_name:'finding_map',
			name:'finding_map',
		}
	},
};
</script>
